import { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import { ResponsiveContext } from '../../Providers/Responsive';

import { Navigation, PageIndication } from './styles';

const Pagination = ({
  className = '',
  totalArticle = null,
  articlesPerPage = 7,
  currentPage = 1,
  paginate = null,
}) => {
  const intl = useIntl();
  const lastPage = Math.ceil(totalArticle / articlesPerPage);
  const previousPage = currentPage - 1;
  const nextPage = currentPage + 1;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === lastPage;

  const { mobile } = useContext(ResponsiveContext);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }, [currentPage]);

  return (
    <nav
      role="navigation"
      aria-label="Pagination Navigation"
      className={className}
    >
      <Navigation className="no-bullets">
        <li>
          <button
            type="button"
            className="first"
            disabled={isFirstPage}
            onClick={() => {
              paginate(1);
            }}
          >
            {intl.formatMessage({
              id: 'first',
            })}
          </button>
        </li>
        <li>
          <button
            type="button"
            disabled={isFirstPage}
            onClick={() => {
              paginate(previousPage);
            }}
          >
            {intl.formatMessage({
              id: 'previous',
            })}
          </button>
        </li>
        <li className={mobile ? 'mobile-hide' : ''}>
          <PageIndication>
            {`${currentPage} ${intl.formatMessage({
              id: 'paginationOf',
            })} ${lastPage}`}
          </PageIndication>
        </li>
        <li>
          <button
            type="button"
            disabled={isLastPage}
            onClick={() => {
              paginate(nextPage);
            }}
          >
            {intl.formatMessage({
              id: 'next',
            })}
          </button>
        </li>
        <li>
          <button
            type="button"
            className="last"
            disabled={isLastPage}
            onClick={() => {
              paginate(lastPage);
            }}
          >
            {intl.formatMessage({
              id: 'last',
            })}
          </button>
        </li>
      </Navigation>
    </nav>
  );
};

Pagination.propTypes = {
  className: PropTypes.string,
  articlesPerPage: PropTypes.number,
  totalArticle: PropTypes.number,
  currentPage: PropTypes.number,
  paginate: PropTypes.func,
};

export default Pagination;
